import z from "zod";

import { SIZES } from "@frontend/styles/constants";

import { AVATAR_KINDS, AVATAR_STATUSES, AVATAR_VARIANTS } from "./constants";

export const avatarDataSchema = z.object({
  url: z
    .string()
    .optional()
    .describe("Picture to show, when the record carries one."),
  size: z.enum(SIZES).optional(),
  variant: z
    .enum(AVATAR_VARIANTS)
    .optional()
    .describe("Colours of the fallback."),
  kind: z
    .enum(AVATAR_KINDS)
    .optional()
    .describe(
      "Picks the default icon and rounding: a circle and a person for `person`, a rounded square and a building for `organization`.",
    ),
  bordered: z.coerce.boolean().optional(),
  invalid: z.coerce
    .boolean()
    .optional()
    .describe(
      "Validation state, read like a field's: an edge in the error colour.",
    ),
  success: z.coerce
    .boolean()
    .optional()
    .describe(
      "Validation state, read like a field's: an edge in the success colour.",
    ),
  status: z
    .enum(AVATAR_STATUSES)
    .optional()
    .describe("Presence dot on the bottom-right edge."),
  disabled: z.coerce.boolean().optional(),
  fallback: z
    .string()
    .optional()
    .describe("Text standing in for the picture, typically initials."),
});

export type AvatarDataProps = z.infer<typeof avatarDataSchema>;
